import { Bar, Doughnut, Line, Pie, Bubble, Radar, HorizontalBar, Scatter, Polar } from 'react-chartjs-2';
import { useQuery } from 'react-query';
import queryConfig from '../../util/queryConfig';
import useApi from '../../api';
import Throbber from '../throbber/Throbber';
import Error from '../error/Error';
import { QueryKey } from '../../constants/queryKey';

const ReportChart = ({report, filter, scenarios}) => {
    const { getReport } = useApi();
    const {isLoading, error, data} = useQuery([QueryKey.Reports, {slug: report.slug, year: filter.year, month: filter.month}], async () => {
        const response = await getReport(report.slug, filter);

        return response.data;
    }, queryConfig);

    const Graph = {
        DOUGHNUT: Doughnut,
        PIE: Pie,
        LINE: Line,
        SCATTER: Scatter,
        BAR: Bar,
        HORIZONTALBAR: HorizontalBar,
        RADAR: Radar,
        POLAR: Polar,
        BUBBLE: Bubble,
    }[report?.type ? report.type.toUpperCase() : 'BAR'];

    const groupGraphData = () => {
        if (!scenarios || !data) {
            return;
        }
        return report.groupData({
            rows: data.rows.map((row) => {
                const scenario = scenarios.find((s) => s.scenario_id === row.scenario);
                return {
                    ...row,
                    scenario: scenario?.name || row.scenario,
                }
            })
        });
    };

    return (
        <div className="chart">
            {isLoading ? (
                <Throbber title="Loading report"/>
            ) : error ? (
                <Error msg="Something went wrong loading this report."/>
            ) : (
                <Graph {...groupGraphData()} options={{ maintainAspectRatio: false }} height={180} />
            )}
        </div>
    )
};

export default ReportChart;
